"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var common_1 = require("stremio/common");
var CONSTANTS_1 = require("stremio/common/CONSTANTS");
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var useStreamingServer_1 = __importDefault(require("stremio/common/useStreamingServer"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Item_less_1 = __importDefault(require("./Item.less"));
var classnames_1 = __importDefault(require("classnames"));
var useStreamingServerUrls_1 = __importDefault(require("../useStreamingServerUrls"));
var Item = function (_a) {
    var _b, _c;
    var _d, _e;
    var url = _a.url;
    var t = (0, react_i18next_1.useTranslation)().t;
    var profile = (0, common_1.useProfile)();
    var streamingServer = (0, useStreamingServer_1.default)();
    var _f = (0, useStreamingServerUrls_1.default)(), deleteServerUrl = _f.deleteServerUrl, selectServerUrl = _f.selectServerUrl;
    var selected = (0, react_1.useMemo)(function () { return profile.settings.streamingServerUrl === url; }, [url, profile.settings]);
    var defaultUrl = (0, react_1.useMemo)(function () { return url === CONSTANTS_1.DEFAULT_STREAMING_SERVER_URL; }, [url]);
    var handleDelete = (0, react_1.useCallback)(function () {
        deleteServerUrl(url);
        selected && selectServerUrl(CONSTANTS_1.DEFAULT_STREAMING_SERVER_URL);
    }, [url, selected]);
    var handleSelect = (0, react_1.useCallback)(function () {
        selectServerUrl(url);
    }, [url]);
    return (react_1.default.createElement("div", { className: Item_less_1.default['item'] },
        react_1.default.createElement("div", { className: Item_less_1.default['content'] },
            react_1.default.createElement(components_1.RadioButton, { className: Item_less_1.default['selectable'], selected: selected, onChange: handleSelect, disabled: selected }),
            react_1.default.createElement("div", { className: Item_less_1.default['label'] }, url)),
        react_1.default.createElement("div", { className: Item_less_1.default['actions'] },
            selected ?
                react_1.default.createElement("div", { className: Item_less_1.default['status'] },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(Item_less_1.default['icon'], (_b = {}, _b[Item_less_1.default['ready']] = ((_d = streamingServer.settings) === null || _d === void 0 ? void 0 : _d.type) === 'Ready', _b), (_c = {}, _c[Item_less_1.default['error']] = ((_e = streamingServer.settings) === null || _e === void 0 ? void 0 : _e.type) === 'Err', _c)) }),
                    react_1.default.createElement("div", { className: Item_less_1.default['label'] }, streamingServer.settings === null ?
                        'NotLoaded'
                        :
                            streamingServer.settings.type === 'Ready' ?
                                t('SETTINGS_SERVER_STATUS_ONLINE')
                                :
                                    streamingServer.settings.type === 'Err' ?
                                        t('SETTINGS_SERVER_STATUS_ERROR')
                                        :
                                            streamingServer.settings.type))
                : null,
            !defaultUrl ?
                react_1.default.createElement(components_1.Button, { className: Item_less_1.default['delete'], onClick: handleDelete },
                    react_1.default.createElement(react_2.default, { name: 'bin', className: Item_less_1.default['icon'] }))
                : null)));
};
exports.default = Item;
